import createWrappedField from './createWrappedField'
import TF from '../WebAddressTextField'

export default createWrappedField({
  Component: TF,
  name: 'DDIWebAddressTextField'
})
